"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_1 = require(36);
function withState(stateName, setterName, initialState) {
    return create_1.create({
        initialize: function () {
            var _this = this;
            this.props[stateName] = initialState;
            this.props[setterName] = function (value) {
                var _a;
                _this.set((_a = {},
                    _a[stateName] = value,
                    _a));
            };
        },
    });
}
exports.withState = withState;
//# sourceMappingURL=withState.js.map